/**
 * SettingsAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SettingsAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M5.277 4.6a3.4 3.4 0 0 1 6.559 0H21a.9.9 0 0 1 0 1.8h-9.165a3.4 3.4 0 0 1-6.559 0H3a.9.9 0 1 1 0-1.8zm2.148-.231a1.6 1.6 0 1 1-.464 1.258 1 1 0 0 0 0-.254 1.6 1.6 0 0 1 .464-1.004M21 12.9h-2.277a3.4 3.4 0 0 1-6.559 0H3a.9.9 0 0 1 0-1.8h9.165a3.4 3.4 0 0 1 6.559 0H21a.9.9 0 0 1 0 1.8m-3.96-.9q0-.034.003-.069a1.6 1.6 0 1 0 0 .137zm-5.205 7.4a3.4 3.4 0 0 1-6.559 0H3a.9.9 0 0 1 0-1.8h2.277a3.4 3.4 0 0 1 6.559 0H21a.9.9 0 0 1 0 1.8zm-4.878-.832a1 1 0 0 0 0-.136 1.6 1.6 0 1 1 0 .136"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SettingsAltIcon = makeIcon('SettingsAltIcon', SettingsAltIconSvg)
